import { Component, ViewChild, Input, ElementRef } from '@angular/core';
import { FilterService, GridComponent } from '@syncfusion/ej2-angular-grids';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { ProductService } from '../../../services/Product.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import '@angular/localize/init';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EActionTypes, EToaster, EUserSecurityFunctionID } from "src/app/Shared/enum";
import { IUserPermissionHandler } from "src/app/Shared/model/CommonModel";
import { UserPermissionHandlerDirective } from "src/app/Shared/userPermissionHandler.directive";
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { GeneralService } from 'src/app/services/general.service';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
declare var $: any;

@Component({
  selector: 'app-ops-product-category',
  standalone: true,
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent, TopBarComponent,UserPermissionHandlerDirective, LoaderComponent],
  providers: [FilterService],
  templateUrl: './ops-product-category.html',
  styleUrl: './ops-product-category.scss'
})

export class OpsProductCategory {
  isCollapsed: boolean = true;
  @ViewChild('gridProductCategory', { static: false }) public gridProductCategory: GridComponent;
  @ViewChild('productCategoryModal', { static: false }) productCategoryModal: ElementRef;

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  modalRef!: NgbModalRef;
  @Input() activeColor: string = '#28a745'; 
  @Input() inactiveColor: string = '#dc3545'; 

  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.ProductCategory, Action: EActionTypes.VIEW };
  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.ProductCategory, Action: EActionTypes.CREATE };
  deletePermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.ProductCategory, Action: EActionTypes.DELETE };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.ProductCategory, Action: EActionTypes.EDIT };

  constructor(private formBuilder: FormBuilder,
    private productService: ProductService,
    private generalService: GeneralService,
    private toastr: ToastrService,
    private formbuilder: FormBuilder,
    private sharedHTMLSettings: SharedHTMLSettingsDataService) {
    this.productCategory = this.formBuilder.group({
      rdocategory: ['0']
    });
    this.createProductCategory = this.formbuilder.group({
      productCategoryName: ['', [Validators.required]],
      selectedColor: ['#0000', [Validators.required]],
      categoryActive: [true],
      productCategoryId: [0]
    })
  }

  private subscriptions: Subscription[] = [];
  marketId: number;
  categoriesList = [];
  categoriesListToFilter = [];
  productCategory: FormGroup;
  createProductCategory: FormGroup;
  disableSave = false;
  loaderIcon: Promise<boolean> = Promise.resolve(false);
  sub;
  response;
  isCreateFormVisible;
  isEditMode = false;

  ngOnInit(): void {
    this.loaderIcon = Promise.resolve(true);
    this.getProductCategories();
  }

  get editRight(): boolean {
    return this.generalService.getUserPermissionsForModule(EUserSecurityFunctionID.ProductCategory).EditRight;
  }

  checkProductSetForCategory() {
    var data = [];
    if (this.createProductCategory.value['productCategoryId'] != 0 && !this.createProductCategory.value['categoryActive']) {
      data.push(this.createProductCategory.value['productCategoryId'])
      this.subscriptions.push(
        this.sub = this.productService.GetCategoriesSetForProducts(data).subscribe((res: any) => {
          if (res.length > 0) {
            this.toastr.error($localize`Category cannot be made inactive. Products are defined under this category`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
            this.createProductCategory.patchValue({
              categoryActive: true
            });
          }
        }));
    }
  }

  onProductCategoryRowSelected(event: any): void {
    const data = event.data;
    this.isEditMode = true; 
    if (!this.editRight) {
      this.toastr.info(
        EToaster.MsgInfoNoRightToEdit + $localize`:@@ProductCategory:Product Category`,
        EToaster.TitleInfo,
        this.sharedHTMLSettings.ToasterConfig
      );
      return;
    }
    console.log('Selected Row:', data);
    this.createProductCategory.patchValue({
      productCategoryId: data.id,
      productCategoryName: data.category,
      selectedColor: data.color,
      categoryActive: !data.activeInactive
    });
    const modal = this.productCategoryModal.nativeElement;
    $(modal).modal('show');
    modal.classList.add('show');
  }

  getProductCategories() {
    this.subscriptions.push(
      this.productService.GetAllProductCategories().subscribe(
        (res: any) => {
          if (res) {
            const filtered = res.filter(el => el.CatBitDeleteFlag !== true);
            const mapped = filtered.map((el: any) => ({
              id: el.CatSeqCategoryId,
              category: el.CatTxtCategoryDescr,
              color: this.convertColor(el.CatNumColor),
              activeInactive: el.CatBlnCategoryInactive
            }));
            this.categoriesList = mapped;
            this.categoriesListToFilter = [...mapped];
          }
          this.loadFilteredList();
          this.loaderIcon = Promise.resolve(false);
        },
        (err) => {
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error('Failed to fetch product categories.', 'Error', this.sharedHTMLSettings.ToasterConfig);
        }
      )
    );
    
  }

  convertColor(colorValue: number): string {
    if (colorValue === null || colorValue === undefined) {
      return '#ffffff'; 
    }
    return '#' + colorValue.toString(16).padStart(6, '0');
  }

  loadFilteredList() {
    const selected = this.productCategory.get('rdocategory').value;
    switch (selected) {
      case '1':
        this.categoriesList = this.categoriesListToFilter.filter(e => e.activeInactive === false || e.activeInactive === null);
        break;
      case '2':
        this.categoriesList = this.categoriesListToFilter.filter(e => e.activeInactive === true);
        break;
      default:
        this.categoriesList = [...this.categoriesListToFilter];
        break;
    }
  }

  saveProductCategory(): void {
    if (this.createProductCategory.invalid) {
      this.createProductCategory.markAllAsTouched();
      return;
    }
    this.disableSave = true;
    const formValue = this.createProductCategory.value;
    const formCategoryId = formValue['productCategoryId'] ?? 0;
  
    const rawName = formValue['productCategoryName'] ?? '';
    const rawColor = formValue['selectedColor'] ?? '';
    const rawActive = formValue['categoryActive'];
  
    const formName = rawName.trim().toLowerCase();
    const formColor = rawColor.trim().toLowerCase();
  
   if (!formName) {
      this.toastr.error(
        $localize`Category name cannot be empty.`,
        $localize`Failed`,
        this.sharedHTMLSettings.ToasterConfig
      );
      this.disableSave = false;
      return;
    }
  
    const isNew = formCategoryId === 0;
    const existingCategory = !isNew? this.categoriesListToFilter.find(item => item.id === formCategoryId): null;
    const isNameChanged = existingCategory && existingCategory.category?.toLowerCase().trim() !== formName;
    const isColorChanged = existingCategory && existingCategory.color?.toLowerCase().trim() !== formColor;
    const isActiveChanged =existingCategory && existingCategory.activeInactive !== !rawActive;
  
    if (!isNew && !isNameChanged && !isColorChanged && !isActiveChanged) {
      this.toastr.info(
        $localize`No changes detected to save.`,
        $localize`Info`,
        this.sharedHTMLSettings.ToasterConfig
      );
      this.disableSave = false;
      return;
    }
  
    const isDuplicateName = (isNew || isNameChanged) && this.categoriesListToFilter.some(item =>
        item.category?.toLowerCase().trim() === formName && item.id !== formCategoryId
      );
  
    const isDuplicateColor = (isNew || isColorChanged) && this.categoriesListToFilter.some(item =>
        item.color?.toLowerCase().trim() === formColor && item.id !== formCategoryId
      );
  
    if (isDuplicateName || isDuplicateColor) {
      let message = '';
      if (isDuplicateName) message += $localize`Category name already exists. `;
      if (isDuplicateColor) message += $localize`Color already in use. Please choose a different color`;
      this.toastr.error(message.trim(), $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
      this.disableSave = false;
      return;
    }
    formValue['productCategoryName'] = rawName.trim();
    this.confirmAndSave(formValue);
  }
  
  private confirmAndSave(formValue: any): void {
    Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure you want to save this Category details?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.loaderIcon = Promise.resolve(true);
        const saveObj = [{
          CategoryId: formValue['productCategoryId'],
          CategoryDescription: formValue['productCategoryName'],
          Color: parseInt(formValue['selectedColor'].replace('#', ''), 16),
          CategoryInactive: !formValue['categoryActive'],
          DeleteFlag: false
        }];
        this.closeModal();
        this.subscriptions.push(
          this.productService.SaveProductCategories(saveObj).subscribe({
            next: (response) => {
              this.loaderIcon = Promise.resolve(false);
              this.disableSave = false;
              if (response === true || response ?.Success) {
                this.toastr.success('Category has been saved successfully.', 'Saved!', this.sharedHTMLSettings.ToasterConfig);
                this.getProductCategories();
                this.resetFormWithDefaults();
              } else {
                this.toastr.error('Color or Category already in use.Failed to save.', 'Error', this.sharedHTMLSettings.ToasterConfig);
              }
            },
            error: (err) => {
              this.loaderIcon = Promise.resolve(false);
              this.disableSave = false;
              console.error('Save failed:', err);
              this.toastr.error('Failed to save Category.', 'Error', this.sharedHTMLSettings.ToasterConfig);
            }
          })
        );
      } else {
        this.disableSave = false;
      }
    });
  }

  deleteProductCategory(CategoryId) {
    const selectedCategory = this.categoriesList.find(ele => ele.id === CategoryId);
    if (!selectedCategory) {
      this.toastr.error($localize`Selected category not found`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
      return;
    }
    Swal.fire({
      title: $localize`Are you sure?`,
      text: $localize`The category will be deleted.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes, delete it!`,
      cancelButtonText: $localize`Cancel`
    }).then((result) => {
      if (result.isConfirmed) {
        this.loaderIcon = Promise.resolve(true);
        const categoryIdList = [CategoryId];
        this.subscriptions.push(
          this.productService.GetCategoriesSetForProducts(categoryIdList).subscribe((res: any[]) => {
            if (res.length > 0) {
              this.toastr.error($localize`Product category cannot be deleted! Since it is already assigned to the product.`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
              this.loaderIcon = Promise.resolve(false);
              return;
            }
            const obj = [{
              CategoryId: selectedCategory.id,
              CategoryDescription: selectedCategory.categoryName,
              Color: selectedCategory.color ? parseInt(selectedCategory.color.substr(1), 16) : '',
              CategoryInactive: selectedCategory.inActive,
              DeleteFlag: true
            }];
            this.subscriptions.push(
              this.productService.SaveProductCategories(obj).subscribe((res: any[]) => {
                this.response = res;
                if (this.response.Success) {
                    this.toastr.success($localize`Category deleted successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
                  this.getProductCategories();
                  this.modalRef.close();
                } else {
                  this.toastr.error($localize`Product category delete was unsuccessful`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
                }
                this.loaderIcon = Promise.resolve(false);
              }, (err) => {
                this.toastr.error($localize`Delete was unsuccessful`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
                this.loaderIcon = Promise.resolve(false);
              })
            );
          })
        );
      }
    });
  }

  resetFormWithDefaults(): void {
    this.createProductCategory.reset({
      productCategoryName: '',
      selectedColor: '#000000',
      categoryActive: true,
      productCategoryId: 0
    });
    this.createProductCategory.markAsPristine();
    this.createProductCategory.markAsUntouched();
  }

  openCreateCategoryModal(): void {
    this.isEditMode = false;  
    this.disableSave = false; 
    this.resetFormWithDefaults();
    this.getProductCategories();
    const modal = this.productCategoryModal.nativeElement;
    $(modal).modal('show');
  }

  closeModal() {
    const modal = this.productCategoryModal.nativeElement;
    if (modal.classList.contains('show')) {
      $(modal).modal('hide');
      setTimeout(() => {
        modal.style.display = 'none';
        modal.classList.remove('show');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
      }, 300);
    }
  }

  disableNewCategorySave() {
    if (this.createProductCategory.invalid) {
      return true
    } else {
      return false
    }
  }

  dataBound(args) {
    Object.assign((<any>this.gridProductCategory.filterModule).filterOperators, { startsWith: 'contains' });
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  public created(args1) {
    this.gridProductCategory.element.querySelectorAll('.e-filterdiv')[this.gridProductCategory.getColumnIndexByField('activeInactive')].classList.add('e-hide');
    this.gridProductCategory.element.querySelectorAll('.e-filterdiv')[this.gridProductCategory.getColumnIndexByField('color')].classList.add('e-hide');
    this.gridProductCategory.element.querySelectorAll('.e-filterdiv')[this.gridProductCategory.getColumnIndexByField('Delete')].classList.add('e-hide');
    this.gridProductCategory.filterSettings = { mode: 'Immediate', immediateModeDelay: 100 };
  }
}
